import { getXsrfToken } from './getXsrfToken';
/**
 * Send a request to the Vend API.
 */
export async function fetchApi(path, options = {}) {
    const response = await fetch(path, Object.assign(Object.assign({ credentials: 'include', redirect: 'error' }, options), { headers: Object.assign(Object.assign({}, options.headers), { 'x-xsrf-token': getXsrfToken() }) }));
    if (response.status === 401) {
        // Redirect to the signin page.
        window.location.href = '/signin?return=' + encodeURI(window.location.href);
    }
    return response;
}
